import React, {useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import RequestOTP from './RequestOTP/RequestOTP';
import VerifyOTP from './VerifyOTP/VerifyOTP';

/**
 * JuryAuth - Main component for jury authentication flow
 * Handles OTP request and verification
 */
function JuryAuth(props) {
    const [step, setStep] = useState('request'); // 'request' or 'verify'
    const [email, setEmail] = useState('');

    const handleOTPRequested = (submittedEmail) => {
        setEmail(submittedEmail);
        setStep('verify');
        const fakeOTP = '12345678';
        console.log('[FAKE AUTH] OTP request for email:', submittedEmail);
        console.log('[FAKE AUTH] Your test code is:', fakeOTP);
    };

    const handleOTPVerified = (otp) => {
        console.log('[FAKE AUTH] OTP verified:', otp, 'for email:', email);
        // TODO: authenticate and redirect
    };

    const handleBackToRequest = () => {
        setStep('request');
        setEmail('');
    };

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col xs={12} sm={12} md={9} lg={7} xl={6}>
                    {step === 'request' ? (
                        <RequestOTP onOTPRequested={handleOTPRequested}/>
                    ) : (
                        <VerifyOTP
                            email={email}
                            onOTPVerified={handleOTPVerified}
                            onBackToRequest={handleBackToRequest}
                        />
                    )}
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col className="text-center mt-5 pt-4">
                    <p className="mb-1">Bei fragen melden sie sich gerne bei uns:</p>
                    <p className="mb-0">
                        <a href="mailto:hilfe@mitmenschen-gemeinsam-stark.de" className="text-primary">
                            hilfe@mitmenschen-gemeinsam-stark.de
                        </a>
                    </p>
                    <p className="mb-0">
                        <a href="tel:0221677746 83" className="text-primary">
                            0221 677 746 83
                        </a>
                    </p>
                </Col>
            </Row>
        </Container>
    );
}

export default JuryAuth;
